import { render, staticRenderFns } from "./ConfirmWaitingQT.vue?vue&type=template&id=1370fa6f&"
import script from "./ConfirmWaitingQT.vue?vue&type=script&lang=js&"
export * from "./ConfirmWaitingQT.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmWaitingQT.vue?vue&type=style&index=0&id=1370fa6f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports